import react, { useState } from 'react';
import ExportCSVOptions from './ExportCSVOptions';
import styles from './Job.module.css';
import Section from '../components/Section/Section';

const JobHeader = (props) => {
    const {
      showEditJob,
      deleteJob,
      job,
    } = props;
  
    return (

        <Section id="pageHeader" bgColor="#f6f6f6">
          <div className="col py-5">
            <div className="row no-gutters flex-column flex-sm-row align-items-start">

              {/* Job Number */}
              <div className={`mb-4 mb-md-0 ${styles.pageHeaderItem} ${styles.jobNumber}`}>
                <div className="d-flex flex-column">
                  <label className={styles.jobLabel}>Job</label>
                  <div className={styles.jobInfoDisplay}>
                    {job.job_number}
                  </div>
                  <a className="btn-link danger" href="#" onClick={deleteJob}>Delete Job</a>
                </div>
              </div>

              {/* Foreman */}
              <div className={`mb-4 mb-md-0 ${styles.pageHeaderItem} ${styles.jobForeman}`}>
                <div className="d-flex flex-column">
                  <label className={styles.label}>Foreman</label>
                  <div className={styles.jobInfoDisplay}>
                    {job.foreman_name}
                  </div>
                </div>
              </div>

              {/* Utility */}
              <div className={`mb-4 mb-md-0 ${styles.pageHeaderItem} ${styles.jobUtility}`}>
                <div className="d-flex flex-column">
                  <label className={styles.label}>Utility</label>
                  <div className={styles.jobInfoDisplay}>
                    {job.selected_utility_name}
                  </div>
                </div>
              </div>
                
              {/* Due Date */}
              <div className={`mb-4 mb-md-0 ${styles.pageHeaderItem} ${styles.jobDueDate}`}>
                <div className="d-flex flex-column">
                  <label className={styles.label}>Due Date</label>
                  <div className={styles.jobInfoDisplay}>
                  {job.due_date ? job.due_date : ''}
                  </div>
                </div>
              </div>
                
              {/* Date Completed */}
              <div className={`${styles.pageHeaderItem} ${styles.jobCompleted}`}>
                <div className="d-flex flex-column">
                  <label className={styles.label}>Date Completed</label>
                  <div className={styles.jobInfoDisplay}>
                    {
                    job.date_completed ? new Intl.DateTimeFormat("en-US", {
                        year: "numeric",
                        month: "long",
                        day: "2-digit"
                      }).format(new Date(job.date_completed)) : '--'
                    }
                  </div>
                </div>
              </div>
                
              {/* Edit Job Info btn */}
              <div className={`${styles.pageHeaderItem} ${styles.jobEdit}`}>
                <div className="d-flex flex-column">
                  <label className={styles.label} style={{opacity: 0}}>Edit Job</label>
                  <button type="button" className="btn btn-t text-center" onClick={showEditJob}>Edit Job Info</button>
                </div>
              </div>
          
              {/* Export Job Options */}
              <div className={`${styles.pageHeaderItem} ${styles.jobExport}`}>
                <div className="d-flex flex-column">
                  <label className={styles.label} style={{opacity: 0}}>Export Job</label>
                  <ExportCSVOptions job={job} />
                </div>
                </div>
                    
            </div>
          </div>              
        </Section>
    );
}
export default JobHeader;        
        